export default class AssistantRequestAPIRequest {
  public message?: string;
  public userId?: string;
  public previousResponseId?: string;
  public currentRoute?: string;
}
